<template>
  <div>
    <a-card
      :bordered="false"
      :body-style="{ padding: '12px 16px' }"
      style="margin-bottom: 16px"
    >
      <div class="module-header-fs14" style="margin-bottom: 8px">
        业务接入情况
      </div>

      <div v-if="accessStatusData" :size="16" class="statistic-card">
        <template v-for="(v, k) in accessStatusData">
          <div :key="k" :class="['access-item', k]">
            <div>
              <div class="title">{{ $t(`service_access_status.${k}`) }}</div>
              <div class="value">{{ isNotUndefined(v) ? v : '-' }}</div>
            </div>
          </div>
        </template>
      </div>
    </a-card>

    <a-card
      :bordered="false"
      style="margin-bottom: 16px"
      :body-style="{ padding: '16px' }"
    >
      <div class="table-operation-container">
        <a-space size="middle" style="float: right">
          <a-input-group :compact="true">
            <a-select
              v-model="searchType"
              :options="tableSearchOptions"
              style="min-width: 96px; border-right: 1px solid #fff"
            >
              <a-icon slot="suffixIcon" type="caret-down"></a-icon>
            </a-select>

            <a-input-search
              placeholder="请输入关键词"
              @search="v => handleSearch(v)"
              style="width: 160px"
            ></a-input-search>
          </a-input-group>
          <!-- 刷新 -->
          <reload-button @click="fetchTableData"></reload-button>

          <!-- 导出 -->
          <export-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            :export-func="exportFunc"
            :params="fetchParams"
            title="业务监控建设情况"
          ></export-button>

          <!-- 设置 -->
          <setting-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            @selected="handleColumnSelect"
          ></setting-button>
        </a-space>
      </div>

      <a-table
        rowKey="id"
        ref="table"
        class="custom-table scroll-hidden-table"
        :data-source="tableData"
        :columns="columns"
        :loading="loading"
        :scroll="{ x: scrollX }"
        :pagination="false"
        @change="handleTableChange"
      >
        <!-- 业务名字 -->
        <template slot="service_name" slot-scope="text">
          <template v-if="text">
            <a-tooltip :title="text">
              {{ text }}
            </a-tooltip>
          </template>
          <span v-else>-</span>
        </template>
        <!-- 责任处室 -->
        <template slot="organizations" slot-scope="text">
          <template v-if="Array.isArray(text) && text.length">
            <a-tooltip
              v-for="item in text"
              :key="item.id"
              :title="item?.name || ''"
            >
              {{ item?.name || '-' }}
            </a-tooltip>
            <span>&nbsp;&nbsp;</span>
          </template>
          <span v-else>-</span>
        </template>

        <!-- 台账已接入/需接入 -->
        <template slot="asset_added" slot-scope="text, record">
          {{ text }}/{{ record.asset_waited }}
        </template>

        <!-- 数据库添加状态 -->
        <template slot="database_state" slot-scope="text">
          {{ $t(`service_item_state.${text}`) }}
        </template>

        <!-- 中间件添加状态 -->
        <template slot="middleware_state" slot-scope="text">
          {{ $t(`service_item_state.${text}`) }}
        </template>

        <!-- 关键日志接入状态 -->
        <template slot="key_log_state" slot-scope="text">
          {{ $t(`service_item_state.${text}`) }}
        </template>

        <!-- 业务日志接入状态 -->
        <template slot="service_log_state" slot-scope="text">
          {{ $t(`service_item_state.${text}`) }}
        </template>

        <!-- 接入状态 -->
        <template slot="access_state" slot-scope="text">
          <span v-if="text === '-'">-</span>
          <service-access-tag
            v-else
            :text="text.toLowerCase()"
          ></service-access-tag>
        </template>

        <!-- 最新进展 -->
        <template slot="latest_progress" slot-scope="text, record">
          <div class="progress-history-container">
            <a-tooltip v-if="text" :title="text">
              <div class="text-overflow-multiline">
                {{ text }}
              </div>
            </a-tooltip>
            <span v-else>-</span>

            <a-tooltip
              placement="bottomRight"
              overlay-class-name="list-tooltip"
            >
              <template #title>
                <list-tooltip
                  :list-data="
                    formatDateHistory(
                      record.latest_progress_history?.history || [],
                      false
                    )
                  "
                  title="历史进展"
                ></list-tooltip>
              </template>
              <a-button type="link">
                <a-icon type="eye" />
              </a-button>
            </a-tooltip>
          </div>
        </template>

        <!-- 完成时限承诺 -->
        <template slot="promised_date" slot-scope="text, record">
          <div class="progress-history-container">
            <div>
              <template v-if="text">{{
                moment(text).format('YYYY-MM-DD')
              }}</template>
              <template v-else>-</template>
            </div>

            <a-tooltip
              placement="bottomRight"
              overlay-class-name="list-tooltip"
            >
              <template #title>
                <list-tooltip
                  :list-data="
                    formatDateHistory(record.date_history?.history || [])
                  "
                  title="完成时限承诺历史记录"
                ></list-tooltip>
              </template>

              <a-button type="link">
                <a-icon type="eye" />
              </a-button>
            </a-tooltip>
          </div>
        </template>

        <template slot="operation" slot-scope="_, record">
          <edit-button
            v-permission="{ action: 'service.boss.update', effect: 'disabled'}"
            @click="$refs.buildInputDrawer.show(record.id)"
          ></edit-button>
        </template>
      </a-table>

      <div style="height: 36px; margin-top: 16px">
        <a-pagination
          :current="fetchParams.page"
          :pageSize="fetchParams.page_size"
          :show-size-changer="true"
          :show-total="t => `共 ${t} 条`"
          :total="total"
          @change="
            page => {
              fetchParams.page = page
              fetchTableData()
            }
          "
          @showSizeChange="
            (_, pageSize) => {
              fetchParams.page = 1
              fetchParams.page_size = pageSize
              fetchTableData()
            }
          "
          style="float: right"
        ></a-pagination>
      </div>
    </a-card>

    <build-input-drawer
      ref="buildInputDrawer"
      @refresh="fetchTableData"
    ></build-input-drawer>
  </div>
</template>

<script>
import {
  getAccessStatus,
  getServiceAccessList,
  exportServiceAccess
} from '@/api/boss'
import ExportButton from '@/components/button/ExportButton'
import ReloadButton from '@/components/button/ReloadButton'
import SettingButton from '@/components/button/SettingButton'
import ListTooltip from './ListTooltip.vue'
import ServiceAccessTag from '@/components/tag/ServiceAccessTag.vue'
import EditButton from '@/components/button/EditButton.vue'
import BuildInputDrawer from './BuildInputDrawer.vue'
import moment from 'moment'
import { isNotUndefined } from '@/utils'

export default {
  name: 'ServiceBuild',
  components: {
    ExportButton,
    ReloadButton,
    SettingButton,
    ListTooltip,
    ServiceAccessTag,
    EditButton,
    BuildInputDrawer
  },
  computed: {
    scrollX () {
      let sum = 0
      this.columns.forEach(column => {
        sum += column.width
      })
      return sum
    }
  },
  data () {
    return {
      moment,
      isNotUndefined,
      fetchParams: {
        page: 1,
        page_size: 10
      },
      searchType: 'service_name',
      tableSearchOptions: [{ label: '业务系统名称', value: 'service_name' }], // 表格搜索框搜索项
      exportFunc: exportServiceAccess,
      columnsAll: [
        {
          dataIndex: 'service_name',
          title: '业务系统名称',
          fixed: 'left',
          width: 180,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service_name'
          }
        },
        {
          dataIndex: 'organizations',
          title: '责任处室',
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: 'organizations'
          }
        },
        {
          dataIndex: 'service_construction_manager',
          title: '运维公司对接人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service_construction_manager'
          }
        },
        {
          dataIndex: 'asset_added',
          title: '台账已接入/需接入',
          width: 152,
          scopedSlots: {
            customRender: 'asset_added'
          }
        },
        {
          dataIndex: 'database_state',
          title: '数据库添加',
          width: 120,
          scopedSlots: {
            customRender: 'database_state'
          },
          filters: [
            {
              text: '是',
              value: 'YES'
            },
            {
              text: '否',
              value: 'NO'
            },
            {
              text: '-',
              value: '-'
            }
          ],
          filterMultiple: false
        },
        {
          dataIndex: 'middleware_state',
          title: '中间件添加',
          width: 120,
          scopedSlots: {
            customRender: 'middleware_state'
          },
          filters: [
            {
              text: '是',
              value: 'YES'
            },
            {
              text: '否',
              value: 'NO'
            },
            {
              text: '-',
              value: '-'
            }
          ],
          filterMultiple: false
        },
        {
          dataIndex: 'key_log_state',
          title: '关键日志接入',
          width: 132,
          scopedSlots: {
            customRender: 'key_log_state'
          },
          filters: [
            {
              text: '是',
              value: 'YES'
            },
            {
              text: '否',
              value: 'NO'
            },
            {
              text: '-',
              value: '-'
            }
          ],
          filterMultiple: false
        },
        {
          dataIndex: 'service_log_state',
          title: '业务日志接入',
          width: 132,
          scopedSlots: {
            customRender: 'service_log_state'
          },
          filters: [
            {
              text: '是',
              value: 'YES'
            },
            {
              text: '否',
              value: 'NO'
            },
            {
              text: '-',
              value: '-'
            }
          ],
          filterMultiple: false
        },
        {
          dataIndex: 'access_state',
          title: '接入状态',
          width: 140,
          scopedSlots: {
            customRender: 'access_state'
          },
          filters: [
            {
              text: '已完成',
              value: 'FINISHED'
            },
            {
              text: '接入中',
              value: 'PROCESSING'
            },
            {
              text: '已超时',
              value: 'TIMEOUT'
            },
            {
              text: '-',
              value: '-'
            }
          ],
          filterMultiple: false
        },
        {
          dataIndex: 'latest_progress',
          title: '最新进展',
          width: 220,
          scopedSlots: {
            customRender: 'latest_progress'
          }
        },
        {
          dataIndex: 'promised_date',
          title: '完成时限承诺',
          width: 174,
          scopedSlots: {
            customRender: 'promised_date'
          }
        }
      ],
      columnDefaultSelected: [
        'service_name',
        'organizations',
        'service_construction_manager',
        'asset_added',
        'database_state',
        'middleware_state',
        'key_log_state',
        'service_log_state',
        'access_state',
        'latest_progress',
        'promised_date'
      ],
      loading: false, // 表格加载状态
      columns: [],
      tableData: [], // 表格数据
      total: 0, // 表格数据总数
      accessStatusData: {
        finished: null,
        processing: null,
        timeout: null
      } // 接入状态数据
    }
  },
  mounted () {
    this.columns = this.columnsAll.filter(
      column => this.columnDefaultSelected.indexOf(column.dataIndex) !== -1
    )
    this.columns.push({
      dataIndex: 'operation',
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: 100,
      scopedSlots: {
        customRender: 'operation'
      }
    })
    this.fetch()
  },
  methods: {
    fetch () {
      this.fetchAccessStatus()
      this.fetchTableData()
    },
    fetchTableData () {
      this.loading = true
      getServiceAccessList(this.fetchParams)
        .then(res => {
          const data = res.data
          if (data) {
            this.total = data.total
            this.tableData = data.data
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchAccessStatus () {
      getAccessStatus().then(res => {
        if (res.data) {
          for (const key in this.accessStatusData) {
            if (
              Object.prototype.hasOwnProperty.call(this.accessStatusData, key)
            ) {
              this.accessStatusData[key] = res.data?.[key]
            }
          }
        }
      })
    },
    handleSearch (value) {
      if (value !== '') {
        this.fetchParams[this.searchType] = value
      } else {
        delete this.fetchParams[this.searchType]
      }
      this.fetchParams.page = 1
      this.fetchTableData()
    },
    handleTableChange (_, filters) {
      for (const key in filters) {
        if (Object.hasOwnProperty.call(filters, key)) {
          const v = filters[key]
          if (v && v.length) this.fetchParams[key] = v[0]
          else delete this.fetchParams[key]
        }
      }
      this.fetchParams.page = 1
      this.fetchTableData()
    },
    handleColumnSelect (v) {
      this.columns = v
      this.columns.push({
        dataIndex: 'operation',
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: 100,
        scopedSlots: {
          customRender: 'operation'
        }
      })
    },
    formatDateHistory (data, isFormat = true) {
      if (data.length) {
        if (isFormat) {
          return data.map(item => {
            return {
              title: item.content ? this.moment(item.content).format('YYYY-MM-DD') : '-',
              description: item.edit_date
            }
          })
        } else {
          return data.map(item => {
            return {
              title: item.content,
              description: item.edit_date
            }
          })
        }
      }
      return []
    }
  }
}
</script>

<style lang="less" scoped>
.statistic-card {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(188px, 1fr));
  gap: 16px;
  .access-item {
    width: 100%;
    height: 84px;
    border-radius: 6px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // margin: 8px;

    & > div {
      text-align: center;
      padding: 12px 0 0 6px;
      margin-right: 48px;
      overflow: hidden;

      .title {
        font-size: 12px;
      }

      .value {
        font-size: 30px;
        font-weight: 500;
        margin-top: -3px;
      }
    }
  }

  .finished {
    background-image: url('../../../assets/images/service-monitor/access-finished.png');
    color: #4fb860;
  }

  .processing {
    background-image: url('../../../assets/images/service-monitor/access-accessing.png');
    color: #408bf3;
  }

  .timeout {
    background-image: url('../../../assets/images/service-monitor/access-overtime.png');
    color: #f57777;
  }
}

.table-operation-container {
  height: 34px;
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 34px;
  overflow: hidden;
}

.tooltip-closed-container {
  position: absolute;
  top: 4px;
  right: 8px;
  color: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  cursor: pointer;
}

.progress-history-container {
  display: grid;
  grid-template-columns: auto 44px;
  align-items: center;
}
</style>
